import { render, staticRenderFns } from "./ReviewAction.vue?vue&type=template&id=85d5ea8a"
import script from "./ReviewAction.vue?vue&type=script&lang=js"
export * from "./ReviewAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports